import React, { useState } from 'react';
import { ISparkDeposit } from '../../../public/APIContracts/APIContracts';
import SparkDepositModal from 'src/components/SparkDepositModal/SparkDepositModal';
import { SparkDepositsTable } from 'src/components/SparkDepositsTable/SparkDepositsTable';

interface Suite {
  id: string;
  number: string;
  isSpark: boolean;
}

interface SuiteSparkProps {
  suite: Suite;
  sparkDeposits: ISparkDeposit[];
}

export const SuiteSpark = ({ suite, sparkDeposits }: SuiteSparkProps) => {
  const [selectedSparkDeposit, setSelectedSparkDeposit] =
    useState<ISparkDeposit>();

  const handleDepositClick = (deposit: ISparkDeposit, index: number) => {
    setSelectedSparkDeposit(deposit);
  };

  const handleCloseDialogue = () => {
    setSelectedSparkDeposit(null);
  };

  return (
    <div>
      {/* Render Spark Deposits if they exist and suite is a Spark suite. */}
      {suite.isSpark && sparkDeposits && sparkDeposits.length > 0 && (
        <div style={{ marginTop: '2rem' }}>
          <SparkDepositsTable
            sparkDeposits={sparkDeposits}
            onDepositClick={handleDepositClick}
          />
        </div>
      )}
      {/* Render a dialogue with more details for a selected deposit if one is clicked. */}
      {selectedSparkDeposit && (
        <SparkDepositModal
          isOpen={!!selectedSparkDeposit}
          onClose={handleCloseDialogue}
          deposit={selectedSparkDeposit}
        />
      )}
    </div>
  );
};
